<template>
  <main-logo-register class="logo__main" />
  <div>
    <section class="container">
      <div class="container__info">
        <span class="name">¡Ups! Token inválido</span>
      </div>
      <div class="information">
        <p class="info">
          La invitación para tu equipo de trabajo ya ha sido utilizada. Puedes buscar tu
        </p>
        <p class="info">
          equipo de trabajo ingresando el nombre con el que fue creado tu empresa en el
        </p>
        <p class="info">
          siguiente <router-link to="/home" @click="handleHomeLinkClick">link.</router-link>
        </p>
      </div>
      <div class="separator"></div>
    </section>
    <section class="drawing">
      <img src="@/app/register/assets/padlock.png" alt="padlock" />
    </section>
  </div>
</template>

<script>
import { defineComponent } from "vue";

import { WorkspaceEvent } from "@/app/workspace/domain/events";
import EventBus from "@/app/shared/utils/eventBus";

import MainLogoRegister from "@/app/shared/components/molecules/MainLogoRegister.vue";

export default defineComponent({
  components: {
    MainLogoRegister,
  },
  data() {
    return {
      loading: false,
      password: "",
      workspace: "",
    };
  },
  methods: {
    handleHomeLinkClick() {
      setTimeout(() => {
        EventBus.$emit(WorkspaceEvent.OPEN_MODAL_WORKSPACE);
      }, 100);
    },
  },
});
</script>

<style lang="sass" scoped>


.container
  text-align: center

.drawing
  margin-top: 50px
  text-align: center

.container__info
  margin: 0 auto
  margin-top: 100px
  text-align: center
  margin-bottom: 20px

.name
  font-weight: 600
  font-size: 30px

.separator
  margin-bottom: 30px

.button
  width: 100%

.information
  font-size: 20px
  color: $gray-9

.logo__main
  background-color: #ffffff
  padding: 12px 0 0
  margin-top: -20px

.background
  background-color: $background-main

.info
  margin: 0
</style>
